/*
 * Ficha de producto · web blanca.
 * Solo se carga con el ajuste «Web blanca» encendido (sections/main-product).
 *
 * - Al cambiar de formato: −X%, cuotas y puntos del Club, con los mismos
 *   datos que product-page.js (el JSON de variantes de la sección). No toca
 *   el formulario: product-page.js sigue siendo el dueño de la compra.
 * - Hora de corte del despacho (snippets/hora-corte), en hora de Chile.
 * - Hito de Protocol junto a la barra de regalos.
 */
(function () {
  'use strict';

  function pesos(centavos) {
    return '$' + Math.round(centavos / 100).toLocaleString('es-CL');
  }

  /* ---------- Variante elegida → %, cuotas y puntos ---------- */
  function initVariante(root) {
    var json = root.querySelector('[data-product-variants]');
    var idInput = root.querySelector('[data-variant-id]');
    var precio = root.querySelector('[data-product-price]');
    if (!json || !idInput || !precio) return;
    var data;
    try { data = JSON.parse(json.textContent); } catch (e) { return; }

    function variante() {
      var id = String(idInput.value || '');
      if (!id) return null;
      for (var i = 0; i < data.variants.length; i++) {
        if (String(data.variants[i].id) === id) return data.variants[i];
      }
      return null;
    }

    function pintar() {
      var v = variante();

      var pct = root.querySelector('[data-scb-pct]');
      if (pct) {
        // Redondeo hacia abajo, igual que snippets/price: nunca más descuento del que hay.
        var n = v && v.compareAtPrice > v.price ? Math.floor((v.compareAtPrice - v.price) * 100 / v.compareAtPrice) : 0;
        var num = pct.querySelector('[data-scb-pct-n]');
        if (num) num.textContent = String(n);
        pct.classList.toggle('is-hidden', n <= 0);
      }

      var cuotas = root.querySelector('[data-scb-cuotas]');
      if (cuotas) {
        var cn = Number(cuotas.dataset.cuotas || 0);
        var min = Number(cuotas.dataset.cuotasMin || 0);
        var aplica = Boolean(v) && cn > 1 && v.price >= min;
        var cuota = cuotas.querySelector('[data-scb-cuota]');
        if (cuota && aplica) cuota.textContent = pesos(v.price / cn);
        cuotas.classList.toggle('is-hidden', !aplica);
      }

      // Stock: solo se muestra si avisa algo («Últimas X unidades», «Agotado»).
      var stock = root.querySelector('[data-variant-stock]');
      if (stock) stock.classList.toggle('scb-aviso', /últimas|agotado|no disponible/i.test(stock.textContent));

      var club = root.querySelector('[data-scb-club]');
      if (club) {
        var clp = Number(club.dataset.clpPunto || 0);
        var puntos = v && clp > 0 ? Math.floor(v.price / 100 / clp) : 0;
        var p = club.querySelector('[data-scb-puntos]');
        if (p) p.textContent = puntos.toLocaleString('es-CL');
        club.hidden = puntos < 1;
      }
    }

    // product-page.js redibuja el precio cada vez que cambia la variante.
    new MutationObserver(pintar).observe(precio, { childList: true, subtree: true });
    pintar();
  }

  /* ---------- Hora de corte (America/Santiago) ---------- */
  var DIAS = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];

  function ahoraChile() {
    var partes = {};
    new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Santiago', hourCycle: 'h23',
      year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit'
    }).formatToParts(new Date()).forEach(function (p) { partes[p.type] = p.value; });
    return {
      y: Number(partes.year), m: Number(partes.month), d: Number(partes.day),
      min: (Number(partes.hour) % 24) * 60 + Number(partes.minute),
      seg: (Number(partes.hour) % 24) * 3600 + Number(partes.minute) * 60 + Number(partes.second)
    };
  }

  // Fecha de calendario (sin hora) i días después de hoy en Chile.
  function diaMas(hoy, i) {
    var f = new Date(Date.UTC(hoy.y, hoy.m - 1, hoy.d + i, 12));
    return { iso: f.toISOString().slice(0, 10), dow: f.getUTCDay() };
  }

  function dos(n) { return (n < 10 ? '0' : '') + n; }

  /* Cuenta regresiva hasta el próximo corte (9:00 de un día hábil). Antes del
     corte de un día hábil: «despachamos hoy». Si no, cuenta hasta el corte del
     siguiente día hábil: lo que se compra en ese lapso sale ese día. Es
     despacho, no entrega: nunca dice «te llega». */
  function initCorte(el) {
    var hm = String(el.dataset.corte || '9:00').split(':');
    var corteMin = Number(hm[0]) * 60 + Number(hm[1] || 0);
    if (!Number.isFinite(corteMin)) return;
    var corteSeg = corteMin * 60;
    var horaTxt = Number(hm[0]) + ':' + String(Number(hm[1] || 0)).padStart(2, '0');
    var feriados = String(el.dataset.feriados || '').split(',').filter(Boolean);
    var titulo = el.querySelector('[data-corte-titulo]');
    var sub = el.querySelector('[data-corte-sub]');

    function habil(dia) {
      return dia.dow !== 0 && dia.dow !== 6 && feriados.indexOf(dia.iso) === -1;
    }

    function escapar(t) {
      return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
    }

    // {reloj} se dibuja como cajitas HH:MM:SS; el resto del texto va escapado.
    function poner(nodo, plantilla, vars, reloj) {
      if (!nodo) return;
      var t = escapar(plantilla || '');
      Object.keys(vars).forEach(function (k) { t = t.split('{' + k + '}').join(escapar(vars[k])); });
      t = t.split('{reloj}').join(reloj || '');
      nodo.innerHTML = t;
      nodo.hidden = !t;
    }

    function relojHtml(segundos) {
      var h = Math.floor(segundos / 3600);
      var m = Math.floor((segundos % 3600) / 60);
      var s = segundos % 60;
      return '<span class="scb-reloj" role="timer"><b>' + dos(h) + '</b>:<b>' + dos(m) + '</b>:<b>' + dos(s) + '</b></span>';
    }

    function pintar() {
      var hoy = ahoraChile();
      var falta, plantillaT, plantillaS, dia = 'hoy';
      if (habil(diaMas(hoy, 0)) && hoy.seg < corteSeg) {
        falta = corteSeg - hoy.seg;
        plantillaT = el.dataset.txtHoy;
        plantillaS = el.dataset.subHoy;
      } else {
        var i = 1;
        while (i < 15 && !habil(diaMas(hoy, i))) i++;
        var prox = diaMas(hoy, i);
        dia = i === 1 ? 'mañana' : (i < 7 ? 'el ' + DIAS[prox.dow] : 'el próximo día hábil');
        falta = (86400 - hoy.seg) + (i - 1) * 86400 + corteSeg;
        plantillaT = el.dataset.txtLuego;
        plantillaS = el.dataset.subLuego;
      }
      var reloj = relojHtml(falta);
      poner(titulo, plantillaT, { hora: horaTxt, dia: dia }, reloj);
      poner(sub, plantillaS, { hora: horaTxt, dia: dia }, reloj);
      el.hidden = false;
    }

    pintar();
    window.setInterval(pintar, 1000);
  }

  /* ---------- ¿Cómo lo quieres recibir? (snippets/blanca-entrega) ---------- */
  document.addEventListener('click', function (e) {
    var tab = e.target.closest && e.target.closest('[data-scb-entrega-tab]');
    if (!tab) return;
    var caja = tab.closest('[data-scb-entrega]');
    if (!caja) return;
    var cual = tab.getAttribute('data-scb-entrega-tab');
    caja.querySelectorAll('[data-scb-entrega-tab]').forEach(function (t) {
      var on = t === tab;
      t.classList.toggle('is-on', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
    });
    caja.querySelectorAll('[data-scb-entrega-panel]').forEach(function (p) {
      p.hidden = p.getAttribute('data-scb-entrega-panel') !== cual;
    });
  });

  document.addEventListener('keydown', function (e) {
    var tab = e.target.closest && e.target.closest('[data-scb-entrega-tab]');
    if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(e.key)) return;
    var tabs = Array.from(tab.closest('[data-scb-entrega]').querySelectorAll('[data-scb-entrega-tab]'));
    var index = tabs.indexOf(tab);
    if (e.key === 'Home') index = 0;
    else if (e.key === 'End') index = tabs.length - 1;
    else index = (index + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
    e.preventDefault();
    tabs[index].click();
    tabs[index].focus();
  });

  /* ---------- Hito de Protocol junto a la barra de regalos ---------- */
  function pintarProtocol() {
    document.querySelectorAll('[data-scb-regalos]').forEach(function (caja) {
      var proto = caja.querySelector('[data-scb-proto]');
      var barra = caja.querySelector('[data-sc-shipping-progress]');
      if (!proto || !barra) return;
      var total = Number(barra.dataset.eligibleSubtotal || 0);
      proto.classList.toggle('is-reached', total >= Number(proto.dataset.umbral || 0));
    });
  }

  function init() {
    document.querySelectorAll('[data-product-section]').forEach(initVariante);
    document.querySelectorAll('[data-hora-corte]').forEach(initCorte);
    pintarProtocol();
  }

  document.addEventListener('sneakclean:cart-updated', function () {
    // cart-controller.js actualiza la barra; se lee después de que termine.
    window.setTimeout(pintarProtocol, 0);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
}());
